"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('radar-chart', false, function (props) {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.9998 3L45.8741 18.8926L38 45H10L2.12549 18.8926L23.9998 3Z",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38 45L31 37",
    stroke: props.colors[2],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 45L17 37",
    stroke: props.colors[2],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 19L12 22",
    stroke: props.colors[2],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M46 19L36 22",
    stroke: props.colors[2],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 3V13",
    stroke: props.colors[2],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 13L30.0073 17.5706L36 22L31 37H17L12 22L17.9927 17.5706L24 13Z",
    fill: props.colors[3],
    stroke: props.colors[2],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.59406 14.9194L2.12549 18.8926L4.09412 25.4194",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.03125 38.4731L9.99988 45H16.9999",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31 45H38L39.9685 38.4731",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.4053 14.9194L45.8738 18.8926L43.9053 25.4194",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.4684 6.97315L23.9998 3L18.5312 6.97315",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;